'use client';

import { useEffect } from 'react';
import { useUser } from '@/features/auth/shared/hooks/use-user';
import {
  SOCIAL_AUTH_EVENT_PARAM,
  SOCIAL_AUTH_PROVIDER_PARAM,
} from '@/shared/constants/search-params';
import { emitGTMEvent } from '@/features/gtm/shared/helper/emit-gtm-event';

export const SocialAuthGtmListener = () => {
  const { authenticatedUser, loading } = useUser();

  useEffect(() => {
    if (loading) return;
    if (!authenticatedUser) {
      return;
    }
    const params = new URLSearchParams(window.location.search);
    const intent = params.get(SOCIAL_AUTH_EVENT_PARAM);
    const social_provider = params.get(SOCIAL_AUTH_PROVIDER_PARAM);
    if (!intent || !social_provider) {
      return;
    }
    if (intent === 'login') {
      emitGTMEvent('USER_LOGIN', { social_provider });
    } else if (intent === 'signup') {
      emitGTMEvent('USER_SIGNUP', { social_provider, umsGuid: authenticatedUser.umsGuid });
      emitGTMEvent('USER_LOGIN', { social_provider });
    } else if (intent === 'link') {
      //will be implemented later
    }

    params.delete(SOCIAL_AUTH_EVENT_PARAM);
    params.delete(SOCIAL_AUTH_PROVIDER_PARAM);
    const search = params.toString();
    const nextUrl = `${window.location.pathname}${search ? `?${search}` : ''}${window.location.hash}`;
    window.history.replaceState({}, '', nextUrl);
  }, [authenticatedUser, loading]);

  return null;
};
